var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.5 5.417V15.5c0 1.012.821 1.833 1.834 1.833h7.333c1.012 0 1.833-.82 1.833-1.833V5.417m-11 0h-.917m.917 0h1.834m9.166 0h.917m-.917 0h-1.833m-7.333 0V3.583c0-1.012.82-1.833 1.833-1.833h3.667c1.012 0 1.833.82 1.833 1.833v1.834m-7.333 0h7.333m-5.5 3.666v4.584m3.667-4.584v4.584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b34016f1e528b6dcd209426c1d87e854.svg";
export { ForwardRef as ReactComponent };